module.exports = __webpack_public_path__ + "static/media/camera.f5f58d62.png";